(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Mobile filters toggle
  const filtersToggle = document.querySelector('.filters-toggle');
  const filtersClose = document.querySelector('.filters-close');
  const filtersSidebar = document.querySelector('.collection-sidebar');
  const filtersBackdrop = document.querySelector('.filters-backdrop');

  if (filtersToggle) {
    filtersToggle.addEventListener('click', () => {
      filtersSidebar.classList.add('open');
      filtersBackdrop.classList.add('open');
    });
  }

  if (filtersClose) {
    filtersClose.addEventListener('click', () => {
      filtersSidebar.classList.remove('open');
      filtersBackdrop.classList.remove('open');
    });
  }

  if (filtersBackdrop) {
    filtersBackdrop.addEventListener('click', () => {
      filtersSidebar.classList.remove('open');
      filtersBackdrop.classList.remove('open');
    });
  }

  } catch(e) { console.error(e); }
})();
})();
